
<div mat-dialog-title>External accounts ready to import<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
  <mat-dialog-content>
    <div class="block">{{inboundAccounts.length}} of {{data.responseData.totalCount}} external accounts in your file will be added or overwritten in iRebal.</div>
    <div>
      <irb-inventory-grid
        [style.width] = "'100%'"
        [style.height] = "'240px'"
        [showSideBar] = "false"
        [gridOptions] = "gridOptions"
        [frameworkComponents] = 'frameworkComponents'
        [rowData] = 'results'
        (gridReady) = "onGridReady($event)"></irb-inventory-grid>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel entire import</button>
    <button id="continueButton" (click)="completeImport()" class="btn-medium-primary">Finish</button>
  </mat-dialog-actions>
  